import React, { useEffect, useRef, useState } from 'react';
import { color_text_link, color_text_default, color_variants_ocean_light_1, color_text_light, color_defaults_white, color_shades_darker, color_shades_darkest, color_shades_light, color_shades_lighter, color_variants_ocean_light_2, dark_grey_blue } from '../../../constants/colors';
import TemplateSectionStatusModel from '../../../models/templating/TemplateSectionStatusModel';
import HorizontalSeparator from '../../../components/structure/HorizontalSeparator';
import { AppendedSection } from '../../../../clients/spark/scenes/dashboard/ApplicationManagerContent';
import Button from '../../../components/general/Button';
import styled from '@emotion/styled';
import Switch from '../../../components/forms/Switch';
import SparkContainer from '../../../hooks/SparkContainer';
import SparkNewTopicForm from '../../../../clients/spark/scenes/dashboard/SparkNewTopicForm';
import TemplateConfigurationContainer from '../../../state/containers/TemplateConfigurationContainer';
import OrganizationContainer from '../../../state/containers/OrganizationContainer';
import AppliedApplicationTemplateContainer from '../../../state/containers/AppliedApplicationTemplateContainer';
import ConfirmationDialog from '../../../components/structure/ConfirmationDialog';
import WarningConfirmation from '../../../components/general/WarningConfirmation';
import InteractionModelContainer from '../../../hooks/InteractionModelContainer';
import LanguageContainer from '../../../hooks/LanguageContainer';
import LanguageModel from '../../../models/features/api/LanguageModel';
import InteractionModelUpdate from '../../../models/interactionModel/api/InteractionModelUpdate';
import InteractionModel from '../../../models/interactionModel/api/InteractionModel';
import PageError from '../../../components/general/PageError';
import ApplicationContainer from '../../../state/containers/ApplicationContainer';
import ImportFileDialog from '../../../components/general/ImportFileDialog';
import { css } from '@emotion/css';
import TemplateFormFieldValueModel from '../../../models/templating/api/TemplateFormFieldValueModel';
import { columnOneHeading, columnThreeHeading, columnTwoHeading } from '../../../constants/sparkConstants/formFieldImportHeadings';
import useCSVHandler from '../../../hooks/UseCSVHandler';
import useIsMobile from '../../../hooks/UseIsMobile';
import InviteSparkFormModal from './InviteSparkFormModal';
import MemberContainer from '../../../state/containers/MemberContainer';
import { Subscribe } from 'unstated';
import CustomScrollbars from '../../../components/structure/CustomScrollbars';
import useWindowSize from '../../../hooks/UseWindowSize';
import MediaContainer from '../../../state/containers/MediaContainer';
import { AutoGenerateFormFieldResponsesFormModal } from '../../../../clients/spark/scenes/dashboard/autoGenerateFormField/AutoGenerateFormFieldResponsesForm';
import { combineSections, findActiveSectionIndex, CombinedSection, isFieldVisible, getFieldValue } from '../../../utils/sectionUtils';
import SearchField from '../../../components/forms/SearchField';
import * as voicifyApi from '../../../api';
import { TelephonyDeploymentResponse } from '../../../models/telephonyDeployment/TelephonyDeploymentResponse';
import { SparkApplicationClientNotesEditor } from '../../../components/clientContext/SparkClientContextNotesCard';
import moment from 'moment';
import { getGoLiveWarnings } from '../../../utils/goLiveWarningUtils';
import { buildLaunchDateUpdate, confirmLaunchDateUpdate } from '../../../utils/launchDateUpdate';

const completeIcon = require('../../../content/images/templates-icons/complete.svg');
const incompleteIcon = require('../../../content/images/templates-icons/incomplete.svg');
const addCircleIcon = require('../../../content/images/add-circle.svg');
const deleteIcon = require('../../../content/images/spark/close.svg');
const exportIcon = require("../../../content/images/menu-item-icons/file-code-download.svg");
const importIcon = require("../../../content/images/menu-item-icons/file-code-upload.svg");
const shareIcon = require("../../../content/images/share.svg");
const autoGenerateIcon = require('../../../content/images/spark/auto-generate.svg');
const pencilIcon = require('../../../content/images/pencil-blue-small.svg');


interface AppliedAppSectionSelectorProps {
    sections: TemplateSectionStatusModel[] | any[]
    activeSection: TemplateSectionStatusModel
    isFinishSelected?: boolean
    isStartSelected?: boolean
    disabled?: boolean
    isNew?: boolean
    handleActiveSectionChange: (section: TemplateSectionStatusModel) => void
    onFinishSelect: () => void
    onStartSelect: () => void
    firstSectionName?: string,
    hideStart?: boolean
    appendedSections?: AppendedSection[]
    templateConfigContainer: TemplateConfigurationContainer
    orgContainer: OrganizationContainer
    applicationId: string
    appliedAppTemplateContainer: AppliedApplicationTemplateContainer
    appContainer: ApplicationContainer
    appliedAppTemplateId: string
    importedFormFields: TemplateFormFieldValueModel[]
    setImportedFormFields: (fields: TemplateFormFieldValueModel[]) => void
    fileImportErrors: string[]
    setFileImportErrors: (errors: string[]) => void
    handleToggleExpandLeft?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>, expanded: boolean) => void
    showAdminFields?: boolean
    setShowAdminFields?: (show: boolean) => void
    fieldValidationErrors?: Record<string, boolean>
    onFieldSelect?: (fieldId: string) => void
}

const AppliedAppSectionSelector: React.FC<AppliedAppSectionSelectorProps> = (props) => {
    const [showNewTopicModal, setShowNewTopicModal] = useState(false);
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false);
    const [sectionToDelete, setSectionToDelete] = useState(null);
    const [allSections, setAllSections] = useState<CombinedSection[]>([]);
    const [currentFormSections, setCurrentFormSections] = useState<CombinedSection[]>([]);
    const [interactionModels, setInteractionModels] = useState<InteractionModel[]>([]);
    const [languages, setLanguages] = useState<LanguageModel[]>([]);
    const [errors, setErrors] = useState<string[]>([]);
    const [isDeletingSection, setIsDeletingSection] = useState(false);
    const [isImportFileDialogModalOpen, setIsImportFileDialogModalOpen] = useState(false);
    const [isConfirmImportModalOpen, setIsConfirmImportModalOpen] = useState(false);
    const [importedFields, setImportedFields] = useState<TemplateFormFieldValueModel[]>([]);
    const [isShareFormOpen, setIsShareFormOpen] = useState(false);
    const [isAutoAnswerGenerateModalOpen, setIsAutoAnswerGenerateModalOpen] = useState<boolean>(false);
    const [isClientNotesModalOpen, setIsClientNotesModalOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdatingLiveStatus, setIsUpdatingLiveStatus] = useState(false);
    const [goLiveWarnings, setGoLiveWarnings] = useState<string[]>([]);
    const [telephonyDeployments, setTelephonyDeployments] = useState<TelephonyDeploymentResponse[]>([]);
    const [sharedTemplates, setSharedTemplates] = useState<import('../../../models/templating/api/AppliedApplicationTemplateModel').default[]>([]);
    const [sectionSearch, setSectionSearch] = useState('');
    const [isEditingTargetLaunchDate, setIsEditingTargetLaunchDate] = useState(false);
    const [tempTargetLaunchDate, setTempTargetLaunchDate] = useState('');
    const [isEditingLaunchDate, setIsEditingLaunchDate] = useState(false);
    const [tempLaunchDate, setTempLaunchDate] = useState('');
    const targetDateEditorRef = useRef<HTMLDivElement>(null);
    const prevShowAdminFieldsRef = useRef<boolean | undefined>(undefined);

    const sparkContainer = SparkContainer.useContainer();
    const interactionModelContainer = InteractionModelContainer.useContainer();
    const languagesContainer = LanguageContainer.useContainer();
    const { importedData, isLoadingImport, importCSV, exportCSV, setIsLoadingImport } = useCSVHandler();

    const prevSectionsLengthRef = useRef<number | undefined>(undefined);
    const isMobile = useIsMobile();
    const windowSize = useWindowSize();
    const sectionRef = useRef();
    const shouldScrollRef = useRef(false);

    useEffect(() => {
        if (!isEditingTargetLaunchDate) return;

        const dismissOnOutsideClick = (event: PointerEvent) => {
            if (targetDateEditorRef.current && !targetDateEditorRef.current.contains(event.target as Node)) {
                setIsEditingTargetLaunchDate(false);
            }
        };
        const dismissOnEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') setIsEditingTargetLaunchDate(false);
        };

        document.addEventListener('pointerdown', dismissOnOutsideClick);
        document.addEventListener('keydown', dismissOnEscape);
        return () => {
            document.removeEventListener('pointerdown', dismissOnOutsideClick);
            document.removeEventListener('keydown', dismissOnEscape);
        };
    }, [isEditingTargetLaunchDate]);

    useEffect(() => {
        if (importedData?.length) {
            setImportedFields(importedData);
        }
    }, [importedData])

    useEffect(() => {
        if (!languagesContainer.languages.length) {
            languagesContainer.loadLanguages();
        }
        if (!props.sections?.length) {
            getCurrentAppliedTemplate()
        }
    }, []);

    useEffect(() => {
        const loadTelephony = async () => {
            if (!props.applicationId) return;
            try {
                const result = await voicifyApi.getTelephonyDeployments(props.applicationId);
                if (result.resultType === 'Ok') {
                    setTelephonyDeployments(result.data);
                }
            } catch (e) {
                console.error('Failed to load telephony deployments', e);
            }
        };
        loadTelephony();
    }, [props.applicationId]);

    useEffect(() => {
        const loadSharedTemplates = async () => {
            const currentApp = props.appContainer.state.currentApp;
            if (!currentApp) return;
            const orgId = (currentApp as any).organizationId;
            if (!orgId) return;

            try {
                const appsResult = await voicifyApi.getApplicationsWithFeaturesForOrg(orgId);
                if (appsResult.resultType === 'Ok' && appsResult.data) {
                    const sharedConfigApp = appsResult.data.find(app => 
                        app.name === "Shared Configuration" || 
                        app.allowsTemplating || 
                        app.name === "Shared Topics"
                    );
                    if (sharedConfigApp && sharedConfigApp.id) {
                        const templatesResult = await voicifyApi.getAppliedApplicationTemplatesForApp(sharedConfigApp.id);
                        if (templatesResult.resultType === 'Ok') {
                            setSharedTemplates(templatesResult.data);
                        }
                    }
                }
            } catch (e) {
                console.error('Failed to load shared templates', e);
            }
        };
        loadSharedTemplates();
    }, [(props.appContainer.state.currentApp as any)?.organizationId]);

    useEffect(() => {
        // Check if the change in sections length is due to admin fields toggle
        const isAdminFieldsChange = prevShowAdminFieldsRef.current !== undefined &&
            prevShowAdminFieldsRef.current !== props.showAdminFields;

        if (prevSectionsLengthRef.current !== undefined &&
            props.sections.length > prevSectionsLengthRef.current &&
            !isAdminFieldsChange) {
            // A new custom topic was added - we want to scroll to it
            shouldScrollRef.current = true;
            props.handleActiveSectionChange(props.sections[props.sections.length - 1]);
        }
        // Update the previous length and admin fields state
        prevSectionsLengthRef.current = props.sections?.length;
        prevShowAdminFieldsRef.current = props.showAdminFields;
    }, [props.sections?.length, props.showAdminFields]);

    useEffect(() => {
        const app = props.appContainer.state.currentApp;
        const defaultLanguage = languagesContainer.languages.find(l => l.id == app?.defaultLanguageId);
        if (defaultLanguage) {
            const languages = defaultLanguage == null ? [] : [defaultLanguage];
            languagesContainer.updateSelectedLanguages(languages);
        }
    }, [languagesContainer.languages]);

    useEffect(() => {
        if (languagesContainer.currentSelectedLanguages.length > 0) {
            setLanguages(languagesContainer.currentSelectedLanguages);
        }
    }, [languagesContainer.currentSelectedLanguages]);

    const loadInteractionModels = async () => {
        if (props.applicationId && languages.length) {
            const loadInteractionModelsResponse = await interactionModelContainer.loadInteractionModels(props.applicationId, languages);
            if (loadInteractionModelsResponse?.resultType === "Ok") {
                setInteractionModels(loadInteractionModelsResponse.data);
            }
        }
    };

    useEffect(() => {
        loadInteractionModels();
    }, [languages, props.applicationId]);

    useEffect(() => {
        setInteractionModels(interactionModelContainer.interactionModels);
    }, [interactionModelContainer.interactionModels]);

    useEffect(() => {
        const combined = combineSections({
            sections: props.sections ?? [],
            appendedSections: props.appendedSections,
            showAdminFields: sparkContainer.inSpark ? props.showAdminFields ?? false : true,
            importedFormFields: props.importedFormFields,
            appliedAppTemplateContainer: props.appliedAppTemplateContainer
        });

        setAllSections(combined);

        const scopedSections = props.appliedAppTemplateId
            ? (props.sections ?? []).filter((s: any) =>
                !s.appliedTemplateId || s.appliedTemplateId === props.appliedAppTemplateId
            )
            : props.sections ?? [];

        const combinedScoped = combineSections({
            sections: scopedSections,
            appendedSections: props.appendedSections,
            showAdminFields: sparkContainer.inSpark ? props.showAdminFields ?? false : true,
            importedFormFields: props.importedFormFields,
            appliedAppTemplateContainer: props.appliedAppTemplateContainer
        });

        setCurrentFormSections(combinedScoped);
    }, [props.sections, props.appendedSections, props.showAdminFields, props.importedFormFields, props.appliedAppTemplateContainer.state.appliedTemplates, props.appliedAppTemplateId]);

    useEffect(() => {
        if (shouldScrollRef.current && sectionRef?.current) {
            const current = sectionRef.current as HTMLElement;
            current.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
            // Reset the scroll flag
            shouldScrollRef.current = false;
        }
    }, [props.activeSection])

    const getCurrentAppliedTemplate = async () => {
        const loadedTemplatesResult = await props.appliedAppTemplateContainer.loadAppliedTemplates(props.applicationId)
        const loadedTemplate = loadedTemplatesResult.data.find(at => at.id == props.appliedAppTemplateId)
        // The sections will be recombined through the useEffect that watches props.sections
    };

    const activeIndex = findActiveSectionIndex(allSections, props.activeSection);

    const query = sectionSearch.trim().toLowerCase();
    const isFiltering = query.length > 0;

    const filteredResults = isFiltering
        ? currentFormSections.reduce<Array<{ section: CombinedSection, matchingFieldIds: string[] }>>((acc, s) => {
            if (s.sectionType !== 'template') return acc;
            const at = props.appliedAppTemplateContainer.state.appliedTemplates?.find(t => t.id == s.appliedTemplateId);
            const templateFormFieldValues = at?.templateFormFieldValues ?? [];
            const showAdmin = sparkContainer.inSpark ? props.showAdminFields ?? false : true;

            const visibleFields = (s.section?.templateFormFields ?? []).filter((f: any) => {
                const fieldValue = getFieldValue(f, templateFormFieldValues);
                return isFieldVisible(f, fieldValue, showAdmin);
            });

            const titleMatch = s.section?.title?.toLowerCase().includes(query) && visibleFields.length > 0;
            const matchingFields = visibleFields.filter((f: any) =>
                f.title?.toLowerCase().includes(query) ||
                f.label?.toLowerCase().includes(query) ||
                f.associatedVariable?.toLowerCase().includes(query)
            );
            const savedValueMatchingFields = visibleFields.filter((f: any) =>
                templateFormFieldValues.some(
                    (fv: any) => fv.templateFormFieldId === f.id && fv.value?.toLowerCase().includes(query)
                )
            );
            const allMatchingFields = Array.from(new Set([
                ...matchingFields,
                ...savedValueMatchingFields
            ]));
            if (titleMatch || allMatchingFields.length > 0) {
                const fieldIdsToShow = titleMatch
                    ? visibleFields.filter((f: any) => !!f.id).map((f: any) => f.id as string)
                    : allMatchingFields.filter((f: any) => !!f.id).map((f: any) => f.id as string);
                acc.push({ section: s, matchingFieldIds: fieldIdsToShow });
            }
            return acc;
        }, [])
        : [];

    const handleDeleteSectionClick = (section: any) => {
        setSectionToDelete(section);
        toggleDeleteConfirmationModal();
    }

    const toggleDeleteConfirmationModal = () => {
        setIsDeleteConfirmationModalOpen(!isDeleteConfirmationModalOpen);
    };

    const toggleNewTopicModal = () => {
        setShowNewTopicModal(!showNewTopicModal);
    };

    const deleteSection = async () => {

        if (sectionToDelete?.appliedTemplateId) {

            setIsDeletingSection(true);

            const appliedAppTemplateToDelete = props.appliedAppTemplateContainer.state.appliedTemplates.find(appliedAppTemplate => {
                return appliedAppTemplate.id === sectionToDelete.appliedTemplateId;
            });

            if (appliedAppTemplateToDelete) {
                await props.appliedAppTemplateContainer.removeAppliedTemplate(props.applicationId, appliedAppTemplateToDelete.id, result => {
                    if (result.resultType === "Ok") {
                        if (interactionModels?.length) {

                            const interactionModel = interactionModels.find(interactionModel => interactionModel.locale === languages[0].shortCode);

                            const intentToDeleteId = interactionModel?.intents?.find(intent => intent.displayName === appliedAppTemplateToDelete.name)?.id;

                            const interactionModelUpdateRequest: InteractionModelUpdate = {
                                intents: {},
                                disableIntents: [],
                                enableIntents: [],
                                locale: interactionModel.locale,
                                removeCustomIntents: [
                                    {
                                        intentName: appliedAppTemplateToDelete.name,
                                        intentId: intentToDeleteId
                                    }
                                ],
                                addCustomIntents: [],
                                updatedEnhancedIntentMatchingPrompt: interactionModel.enhancedIntentMatchingPrompt,
                                enableEnhancedIntentMatching: interactionModel.useEnhancedIntentMatching,
                            };

                            interactionModelContainer.updateInteractionModel(props.applicationId, languages[0].shortCode, interactionModelUpdateRequest);
                        };
                        props.appliedAppTemplateContainer.loadAppliedTemplates(props.applicationId);

                        // If the deleted section was active, navigate to the first available section or finish
                        const activeSection = props.activeSection as any;
                        const isDeletedSectionActive = activeSection?.appliedTemplateId === sectionToDelete.appliedTemplateId &&
                            (activeSection?.section?.id === sectionToDelete.section?.id ||
                                activeSection?.section?.title === sectionToDelete.section?.title);

                        if (isDeletedSectionActive) {
                            // Navigate to the first section if available, otherwise go to finish
                            if (allSections.length > 1) {
                                // Find a section that's not the one being deleted
                                const nextSection = allSections.find(s =>
                                    s.sectionType !== 'template' ||
                                    s.appliedTemplateId !== sectionToDelete.appliedTemplateId
                                );
                                if (nextSection) {
                                    props.handleActiveSectionChange(nextSection as any);
                                } else {
                                    props.onFinishSelect();
                                }
                            } else {
                                props.onFinishSelect();
                            }
                        }

                        toggleDeleteConfirmationModal();
                    } else {
                        setErrors(result.errors);
                    }
                });
            }

            setIsDeletingSection(false);

        };

    };

    const toggleImportFileDialogModal = () => {
        setIsImportFileDialogModalOpen(!isImportFileDialogModalOpen);
    };

    const toggleConfirmImportModal = () => {
        setIsConfirmImportModalOpen(!isConfirmImportModalOpen);
    };

    const convertCSVTextToTemplateFormFields = (csvArray: string[][]): TemplateFormFieldValueModel[] => {

        const combinedFormFields: TemplateFormFieldValueModel[] = [];

        for (const appliedTemplate of props.appliedAppTemplateContainer.state?.appliedTemplates) {
            const appliedApplicationTemplateId = appliedTemplate.id;
            for (const section of appliedTemplate.templateForm?.templateFormSections) {
                for (const formField of section.templateFormFields) {
                    // Find the actual saved value for this field
                    const savedFieldValue = appliedTemplate.templateFormFieldValues.find(value => value.templateFormFieldId === formField.id);
                    const fieldValue = savedFieldValue ? savedFieldValue.value : (formField.defaultValue || "");

                    const updatedFormField: TemplateFormFieldValueModel = {
                        templateFormFieldId: formField.id,
                        value: fieldValue,
                        associatedVariable: formField.associatedVariable,
                        label: formField.label,
                        fieldType: formField.fieldType,
                        placeholder: formField.placeholder,
                        defaultValue: formField.defaultValue,
                        tip: formField.tip,
                        title: formField.title,
                        appliedApplicationTemplateId: appliedApplicationTemplateId
                    };
                    combinedFormFields.push(updatedFormField);
                }
            }
        };

        const csvRows = csvArray.map(row => row.join(","));
        const headers = csvRows[0].split(",");
        const appliedAppTemplateIdHeadingIndex = headers.findIndex(header => header.toLowerCase() === columnOneHeading.toLowerCase());
        const displayTitleHeadingIndex = headers.findIndex(header => header.toLowerCase() === columnTwoHeading.toLowerCase());
        const assistantResponseHeadingIndex = headers.findIndex(header => header.toLowerCase() === columnThreeHeading.toLowerCase());

        if (displayTitleHeadingIndex === -1 || assistantResponseHeadingIndex === -1) {
            props.setFileImportErrors(["The file you selected is not formatted correctly. Please ensure that the file contains the correct headers."]);
            return [];
        }

        const importedTemplateFormFields: TemplateFormFieldValueModel[] = [];
        let fileImportErrorsList: string[] = [];

        for (const row of csvArray.slice(1)) {
            let appliedAppTemplateId: string;
            if (appliedAppTemplateIdHeadingIndex !== -1) {
                appliedAppTemplateId = row[appliedAppTemplateIdHeadingIndex];
            };
            const displayTitle = row[displayTitleHeadingIndex];
            const assistantResponse = row[assistantResponseHeadingIndex];

            const currentFormFields = combinedFormFields.filter(formField => formField.title === displayTitle);

            let currentFormField: TemplateFormFieldValueModel;

            if (currentFormFields.length > 1) {
                if (appliedAppTemplateId) {
                    currentFormField = currentFormFields.find(formField => {
                        return formField.appliedApplicationTemplateId === appliedAppTemplateId
                    });
                } else {
                    props.setFileImportErrors([`Looks like there is more than one field with the title ${displayTitle}. Please include the module id in the file to specify which field to import.`]);
                }
            } else if (currentFormFields.length === 1) {
                currentFormField = currentFormFields[0];
            };

            if (currentFormField) {
                const importedFormField: TemplateFormFieldValueModel = {
                    ...currentFormField,
                    value: assistantResponse
                };
                importedTemplateFormFields.push(importedFormField);
            } else {
                fileImportErrorsList.push(displayTitle);
            }
        };

        for (const combinedFormField of combinedFormFields) {
            const isImported = importedTemplateFormFields.some(importedFormField => (importedFormField.title === combinedFormField.title) && (importedFormField.appliedApplicationTemplateId ? importedFormField.appliedApplicationTemplateId === combinedFormField.appliedApplicationTemplateId : true));
            if (!isImported) {
                importedTemplateFormFields.push(combinedFormField);
            };
        };

        // ensure all file import errors have a length at all
        fileImportErrorsList = fileImportErrorsList.filter(error => error?.trim()?.length);
        if (fileImportErrorsList.length >= 1) {
            const fileImportErrorsString: string[] = [`We cannot import the following fields, as they're not in this form:`];

            for (const [index, fileImportError] of fileImportErrorsList.entries()) {
                if (index === 2) {
                    fileImportErrorsString[0] += ` ${fileImportError}, ...`;
                    break;
                } else if (index === fileImportErrorsList.length - 1) {
                    fileImportErrorsString[0] += ` ${fileImportError}.`;
                } else {
                    fileImportErrorsString[0] += ` ${fileImportError},`;
                }
            }

            props.setFileImportErrors(fileImportErrorsString);
        }

        return importedTemplateFormFields;
    };

    const importFormFields = (file: File) => {
        importCSV(file, convertCSVTextToTemplateFormFields);
        toggleImportFileDialogModal();
        toggleConfirmImportModal();
    };

    const useImportedTemplateFormFieldValues = async () => {

        setIsLoadingImport(true);

        props.setImportedFormFields(importedFields);
        if (importedFields.length > 0) {
            const appliedTemplates = props.appliedAppTemplateContainer.state?.appliedTemplates;
            if (appliedTemplates) {
                for (const appliedTemplate of appliedTemplates) {
                    const appliedTemplateImportedFormValues = importedFields.filter(importedField => {
                        return appliedTemplate.templateForm?.templateFormSections?.some(section => {
                            return section.templateFormFields.some(field => field.title === importedField.title && (importedField.appliedApplicationTemplateId ? importedField.appliedApplicationTemplateId === appliedTemplate.id : true));
                        });
                    });
                    const updatedAppliedTemplate = {
                        templateFormFieldValues: appliedTemplateImportedFormValues,
                        name: appliedTemplate.name
                    }
                    await props.appliedAppTemplateContainer.updateAppliedTemplate(appliedTemplate?.id, updatedAppliedTemplate);
                };
            };
        };

        setIsLoadingImport(false);
        toggleConfirmImportModal();

    };

    const formatFileName = () => {
        const fileExportName = props.appContainer.state?.currentApp?.name ? props.appContainer.state.currentApp.name.toLowerCase().split(/\s+/) : [];
        const date = new Date();
        const formattedDate = `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
        const formattedTime = `${date.getHours()}:${date.getMinutes()}`;
        fileExportName.push(formattedDate);
        fileExportName.push(formattedTime);
        const formattedFileExportName = fileExportName.join('-');
        return formattedFileExportName;
    };

    const exportFormFields = () => {

        const formFieldValues: any[] = [];

        for (const appliedTemplate of props.appliedAppTemplateContainer.state?.appliedTemplates) {
            for (const section of appliedTemplate.templateForm?.templateFormSections) {
                for (const formField of section.templateFormFields) {
                    const savedFieldValue = appliedTemplate.templateFormFieldValues.find(value => value.templateFormFieldId === formField.id);
                    const fieldValue = savedFieldValue ? savedFieldValue.value : (formField.defaultValue || "");

                    formFieldValues.push({
                        [columnOneHeading]: appliedTemplate.id,
                        [columnTwoHeading]: formField.title,
                        [columnThreeHeading]: fieldValue,
                        associatedVariable: formField.associatedVariable
                    });
                }
            }
        }

        exportCSV(formFieldValues, [columnOneHeading, columnTwoHeading, columnThreeHeading], formatFileName());

    };

    const handleActiveSectionChangeOnMobile = (e: React.PointerEvent<HTMLDivElement>) => {
        props.handleToggleExpandLeft(e, false);
    };

    const handleGoLiveToggle = async (enabled: boolean) => {
        setIsUpdatingLiveStatus(true);
        try {
            const currentApp = props.appContainer.state.currentApp;
            if (!currentApp) return;
            const { launchDate, targetLaunchDate, ...appFieldsToUpdate } = currentApp;
            const updateApplicationResult = await props.appContainer.updateApplication(props.applicationId, {
                ...appFieldsToUpdate,
                OutboundCallIntegrationName: currentApp.outboundCallIntegrationName,
                OutboundCallLocationId: currentApp.outboundCallLocationId,
                isLive: enabled
            } as any);
            if (updateApplicationResult.resultType !== 'Ok') return;
        } finally {
            setIsUpdatingLiveStatus(false);
        }
    };

    useEffect(() => {
        const currentApp = props.appContainer.state.currentApp;
        if (!currentApp || !currentApp.isLive) {
            setGoLiveWarnings([]);
            return;
        }

        const appliedTemplates = props.appliedAppTemplateContainer.getLoadedTemplatesForApp(props.applicationId) ?? [];
        setGoLiveWarnings(getGoLiveWarnings(currentApp, appliedTemplates, sharedTemplates, telephonyDeployments));

    }, [
        props.appContainer.state.currentApp,
        props.appliedAppTemplateContainer.state.appliedTemplates,
        telephonyDeployments,
        sharedTemplates
    ]);

    const handleSaveTargetLaunchDate = async (date = tempTargetLaunchDate) => {
        try {
            const currentApp = props.appContainer.state.currentApp;
            if (!currentApp) return;

            const dateUpdate = buildLaunchDateUpdate(date, false);
            const { launchDate, targetLaunchDate, ...appFieldsToUpdate } = currentApp;

            const updateApplicationResult = await props.appContainer.updateApplication(props.applicationId, {
                ...appFieldsToUpdate,
                OutboundCallIntegrationName: currentApp.outboundCallIntegrationName,
                OutboundCallLocationId: currentApp.outboundCallLocationId,
                ...dateUpdate
            } as any);

            const confirmation = await confirmLaunchDateUpdate(
                updateApplicationResult, date, false,
                () => voicifyApi.findApplication(props.applicationId)
            );
            if (confirmation.saved) {
                if (confirmation.application && date === '') {
                    await props.appContainer.setState(previous => ({
                        ...previous,
                        currentApp: { ...previous.currentApp, ...confirmation.application, targetLaunchDate: null },
                        cachedApplications: previous.cachedApplications?.map(app => app.id === props.applicationId
                            ? { ...app, ...confirmation.application, targetLaunchDate: null } : app),
                        orgApplicationsList: previous.orgApplicationsList?.map(app => app.id === props.applicationId
                            ? { ...app, ...confirmation.application, targetLaunchDate: null } : app)
                    }));
                }
                setIsEditingTargetLaunchDate(false);
            } else {
                setErrors(updateApplicationResult.errors?.length ? updateApplicationResult.errors : [date
                    ? 'Failed to update target launch date.'
                    : 'Target launch date is still set after clearing.']);
            }
        } catch (err) {
            setErrors(['An unexpected error occurred while saving.']);
        }
    };

    const handleSaveLaunchDate = async () => {
        try {
            const currentApp = props.appContainer.state.currentApp;
            if (!currentApp) return;

            const utcZuluString = tempLaunchDate
                ? moment.utc(tempLaunchDate, 'YYYY-MM-DD').toISOString()
                : null;

            const updateApplicationResult = await props.appContainer.updateApplication(props.applicationId, {
                ...currentApp,
                OutboundCallIntegrationName: currentApp.outboundCallIntegrationName,
                OutboundCallLocationId: currentApp.outboundCallLocationId,
                launchDate: utcZuluString
            } as any);

            if (updateApplicationResult.resultType === 'Ok') {
                setIsEditingLaunchDate(false);
            } else {
                setErrors(updateApplicationResult.errors || ['Failed to update launch date.']);
            }
        } catch (err) {
            setErrors(['An unexpected error occurred while saving.']);
        }
    };

    const renderSectionItem = (section: CombinedSection, idx: number, forceInactive?: boolean) => {
        const isActive = !forceInactive && (() => {
            if (section.sectionType === 'template') {
                const activeSection = props.activeSection as any;
                if (activeSection?.appliedTemplateId && activeSection?.section) {
                    // Match by appliedTemplateId AND section properties to ensure uniqueness
                    return activeSection.appliedTemplateId === section.appliedTemplateId &&
                        ((activeSection.section?.name && section?.section?.name === activeSection.section?.name) ||
                            (activeSection.section?.id && section.section?.id === activeSection.section?.id) ||
                            (activeSection.section?.title && section?.section?.title === activeSection.section?.title));
                } else {
                    // Fallback for cases without appliedTemplateId - still check appliedTemplateId if available
                    const activeSectionDetails = activeSection?.section ?? activeSection;
                    // Fallback for cases without appliedTemplateId on activeSection
                    // If both have appliedTemplateId, require both ID and property match
                    if (section.appliedTemplateId && activeSection?.appliedTemplateId) {
                        return activeSection.appliedTemplateId === section.appliedTemplateId &&
                            ((activeSectionDetails?.name && section?.section?.name === activeSectionDetails.name) ||
                                (activeSectionDetails?.id && section.section?.id === activeSectionDetails.id) ||
                                (activeSectionDetails?.title && section?.section?.title === activeSectionDetails.title));
                    }
                    // Otherwise fall back to property-only matching
                    return ((activeSectionDetails?.name && section?.section?.name === activeSectionDetails.name) ||
                        (activeSectionDetails?.id && section.section?.id === activeSectionDetails.id) ||
                        (activeSectionDetails?.title && section?.section?.title === activeSectionDetails.title));
                }
            } else {
                const activeSection = props.activeSection as any;
                return activeSection === section ||
                    (activeSection?.name && section?.name === activeSection?.name) ||
                    (activeSection?.id && section?.id === activeSection?.id);
            }
        })();
        const sectionTitle = section.sectionType === 'template' ? section.section?.title : section.name;

        // Check if this specific section has validation errors
        // The fieldValidationErrors keys are field.id or field.name
        // We need to check if any errors belong to fields in this section
        const sectionFieldIds = section.sectionType === 'template'
            ? section.section?.templateFormFields?.map(f => f.id || f.name) || []
            : [];
        const hasValidationErrorsInThisSection = props.fieldValidationErrors && sectionFieldIds.length > 0
            ? sectionFieldIds.some(fieldId => props.fieldValidationErrors[fieldId] === true)
            : false;

        const isComplete = section.isComplete && !hasValidationErrorsInThisSection;
        const isDisabled = section.sectionType === 'template'
            ? (section.isDisabled || props.isNew)
            : false;

        const shouldShowDeleteButton = section.sectionType === 'template' && section.section?.isCustom;

        return (
            <SectionItem
                ref={isActive ? sectionRef : null}
                key={`${section.sectionType}-${idx}`}
                className={`${(props.disabled && ((idx > activeIndex && !props.isFinishSelected) || props.isStartSelected)) ? "disabled" : ""} ${!props.disabled && !isDisabled ? "clickable" : ""} ${isActive ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}
                onPointerDown={(e) => {
                    if (!isDisabled && !props.disabled) {
                        props.handleActiveSectionChange(section as any);
                        if (isMobile) {
                            handleActiveSectionChangeOnMobile(e);
                        }
                    }
                }}
                onClick={(e: any) => {
                    if (!isDisabled && !props.disabled) {
                        props.handleActiveSectionChange(section as any);
                        if (isMobile) {
                            handleActiveSectionChangeOnMobile(e);
                        }
                    }
                }}
            >
                <SectionTitleWrapper>
                    <SectionTitle>{sectionTitle}</SectionTitle>
                    {shouldShowDeleteButton &&
                        <DeleteButton themes={["icon-small"]} icon={deleteIcon} onClick={() => handleDeleteSectionClick(section)} />
                    }
                </SectionTitleWrapper>
                <CompleteIcon src={isComplete ? completeIcon : incompleteIcon} />
            </SectionItem>
        );
    };

    return (
        <Wrapper>
            {isDeleteConfirmationModalOpen &&
                <ConfirmationDialog
                    title={`Delete ${sectionToDelete.section.title ? sectionToDelete.section.title : 'Section'}`}
                    deleteText="Yes, Delete"
                    isLoading={isDeletingSection}
                    onClose={() => toggleDeleteConfirmationModal()}
                    onConfirm={() => deleteSection()}>
                    <WarningConfirmation
                        text={`Are you sure you want to delete ${sectionToDelete.section.title ? sectionToDelete.section.title : 'this section'}?`}
                    />
                </ConfirmationDialog>
            }
            {
                showNewTopicModal && sparkContainer.inSpark &&
                <SparkNewTopicForm
                    toggleNewTopicModal={toggleNewTopicModal}
                    templateConfigContainer={props.templateConfigContainer}
                    orgContainer={props.orgContainer}
                    appliedAppTemplateContainer={props.appliedAppTemplateContainer}
                    applicationId={props.applicationId}
                    sections={props.sections}
                />

            }
            {!props.hideStart &&
                <>
                    <SectionItem
                        className={`overview-section ${props.isStartSelected ? 'active' : ''}`}
                        onPointerDown={(e) => {
                            if ((!props.isNew || props.disabled)) {
                                props.onStartSelect();
                                if (isMobile) {
                                    handleActiveSectionChangeOnMobile(e);
                                }
                            }
                        }}
                    >
                        <SectionTitle>{props.firstSectionName ? props.firstSectionName : `Overview`}</SectionTitle>
                    </SectionItem>
                    <HorizontalSeparator />
                </>
            }
            <TopicButtonWrapper>
                <CustomScrollbars autoHeight autoHeightMax={(windowSize.windowSize.innerHeight * .45)}>
                    <SearchField
                        placeholder="Search sections..."
                        value={sectionSearch}
                        onChange={e => setSectionSearch(e.target.value)}
                        handleClear={() => setSectionSearch('')}
                        boxType="square"
                        className={searchFieldStyle}
                    />
                    {isFiltering
                        ? filteredResults.map(({ section: s, matchingFieldIds }) => (
                            <div key={`${s.sectionType}-${s.appliedTemplateId}-${s.section?.id}`}>
                                {renderSectionItem(s, allSections.indexOf(s), true)}
                                {matchingFieldIds.map(fieldId => {
                                    const field = (s.section?.templateFormFields ?? []).find((f: any) => f.id === fieldId);
                                    if (!field) return null;
                                    return (
                                        <FieldResultItem
                                            key={fieldId}
                                            onClick={() => props.onFieldSelect?.(fieldId)}>
                                            <p>{field.title || <em>Untitled</em>}</p>
                                        </FieldResultItem>
                                    );
                                })}
                            </div>
                        ))
                        : allSections.map((section, idx) => renderSectionItem(section, idx))
                    }
                    {/* Commenting out in case we want to bring this feature back
                    {sparkContainer.inSpark &&
                        <CustomButton
                            themes={['small-flat']}
                            text="Add a New Topic"
                            rightIcon={addCircleIcon}
                            onClick={() => {
                                toggleNewTopicModal()
                            }}
                        />
                    }
                    */}
                    <SectionItem
                        className={`review-section ${props.isFinishSelected ? 'active' : ''} ${props.isNew ? 'disabled' : ''}`}
                        onPointerDown={(e) => {
                            if (!(props.isNew || props.disabled)) {
                                props.onFinishSelect();
                            }
                            if (isMobile) {
                                handleActiveSectionChangeOnMobile(e);
                            }
                        }}
                    >
                        <SectionTitle>Review</SectionTitle>
                    </SectionItem>
                </CustomScrollbars>
                <ButtonsWrapper>
                    <HorizontalSeparator />
                    {sparkContainer.inSpark &&
                        <FormPopulationButtonWrapper>
                            <FormPopulationButton
                                disabled={false}
                                loading={false}
                                type="submit"
                                themes={['secondary-small', 'end-tight']}
                                rightIcon={importIcon}
                                onClick={() => toggleImportFileDialogModal()}
                                text="Import All Form Fields"
                            />
                            <FormPopulationButton
                                disabled={false}
                                loading={false}
                                type="submit"
                                themes={['secondary-small', 'end-tight']}
                                rightIcon={exportIcon}
                                onClick={() => exportFormFields()}
                                text="Export All Form Fields"
                            />
                            {props.appContainer.state.currentApp && (
                                <FormPopulationButton
                                    disabled={false}
                                    loading={false}
                                    type="button"
                                    themes={['secondary-small', 'end-tight']}
                                    onClick={() => setIsClientNotesModalOpen(true)}
                                    text="View Location Notes"
                                />
                            )}
                            {/* Commenting out for now in case we want to revive these features
                            <FormPopulationButton
                                disabled={false}
                                loading={false}
                                type="submit"
                                themes={['secondary-small', 'end-tight']}
                                rightIcon={shareIcon}
                                onClick={() => setIsShareFormOpen(true)}
                                text="Share Form"
                            />
                            <FormPopulationButton
                                disabled={false}
                                loading={false}
                                type="submit"
                                themes={['secondary-small', 'end-tight']}
                                rightIcon={autoGenerateIcon}
                                onClick={() => setIsAutoAnswerGenerateModalOpen(true)}
                                text="Auto-Generate Responses"
                            />
                            */}
                            {!props.appContainer.state.currentApp?.allowsTemplating
                                && !['shared configuration', 'shared topics'].includes(props.appContainer.state.currentApp?.name?.trim().toLowerCase() ?? '')
                                && <><GoLiveSwitch
                                checked={props.appContainer.state.currentApp?.isLive ?? false}
                                onChange={handleGoLiveToggle}
                                label={props.appContainer.state.currentApp?.isLive ? "Live" : "Not Live"}
                                loading={isUpdatingLiveStatus}
                                disabled={isUpdatingLiveStatus}
                            />
                            {props.appContainer.state.currentApp?.isLive ? (
                                <DateDisplayWrapper>
                                    <DateLabel>Launch Date</DateLabel>
                                    {!isEditingLaunchDate ? (
                                        <DateValueWrapper>
                                            <DateValue>
                                                {props.appContainer.state.currentApp?.launchDate
                                                    ? moment.utc(props.appContainer.state.currentApp.launchDate).format('MMMM D, YYYY')
                                                    : 'Not Set'}
                                            </DateValue>
                                            <PencilIcon
                                                src={pencilIcon}
                                                onClick={() => {
                                                    setTempLaunchDate(
                                                        props.appContainer.state.currentApp?.launchDate
                                                            ? moment.utc(props.appContainer.state.currentApp.launchDate).format('YYYY-MM-DD')
                                                            : ''
                                                    );
                                                    setIsEditingLaunchDate(true);
                                                }}
                                                title="Edit Launch Date"
                                            />
                                        </DateValueWrapper>
                                    ) : (
                                        <DateEditWrapper>
                                            <DateInput
                                                type="date"
                                                value={tempLaunchDate}
                                                onChange={(e) => setTempLaunchDate(e.target.value)}
                                            />
                                            <ActionButtons>
                                                <ActionButton
                                                    onClick={handleSaveLaunchDate}
                                                    title="Save"
                                                >
                                                    Save
                                                </ActionButton>
                                                <ActionButton
                                                    onClick={() => setIsEditingLaunchDate(false)}
                                                    className="cancel"
                                                    title="Cancel"
                                                >
                                                    Cancel
                                                </ActionButton>
                                            </ActionButtons>
                                        </DateEditWrapper>
                                    )}
                                </DateDisplayWrapper>
                            ) : (
                                <DateDisplayWrapper>
                                    <TargetDateLabel>Target Launch Date</TargetDateLabel>
                                    {!isEditingTargetLaunchDate ? (
                                        <DateValueWrapper>
                                            {props.appContainer.state.currentApp?.targetLaunchDate ? (
                                                <TargetDateValue>
                                                    {moment.utc(props.appContainer.state.currentApp.targetLaunchDate).format('MMMM D, YYYY')}
                                                </TargetDateValue>
                                            ) : (
                                                <DateValue>Not Set</DateValue>
                                            )}
                                            <PencilIcon
                                                src={pencilIcon}
                                                onClick={() => {
                                                    setTempTargetLaunchDate(
                                                        props.appContainer.state.currentApp?.targetLaunchDate
                                                            ? moment.utc(props.appContainer.state.currentApp.targetLaunchDate).format('YYYY-MM-DD')
                                                            : ''
                                                    );
                                                    setIsEditingTargetLaunchDate(true);
                                                }}
                                                title="Edit Target Launch Date"
                                            />
                                        </DateValueWrapper>
                                    ) : (
                                        <DateEditWrapper ref={targetDateEditorRef}>
                                            <TargetDateInput
                                                type="date"
                                                value={tempTargetLaunchDate}
                                                onChange={(e) => setTempTargetLaunchDate(e.target.value)}
                                            />
                                            <TargetDateActions>
                                                {!!props.appContainer.state.currentApp?.targetLaunchDate && (
                                                    <ActionButton
                                                        type="button"
                                                        className="cancel compact"
                                                        onClick={() => handleSaveTargetLaunchDate('')}
                                                    >
                                                        Remove
                                                    </ActionButton>
                                                )}
                                                <ActionButton
                                                    type="button"
                                                    className="compact"
                                                    onClick={() => handleSaveTargetLaunchDate()}
                                                    title="Save"
                                                >
                                                    Save
                                                </ActionButton>
                                            </TargetDateActions>
                                        </DateEditWrapper>
                                    )}
                                </DateDisplayWrapper>
                            )}
                            </>}
                            {props.showAdminFields !== undefined && props.setShowAdminFields && (
                                <AdminFieldsSwitch
                                    checked={props.showAdminFields}
                                    onChange={props.setShowAdminFields}
                                    label="Show Admin Fields"
                                />
                            )}
                        </FormPopulationButtonWrapper>
                    }
                </ButtonsWrapper>
            </TopicButtonWrapper>
            {isShareFormOpen &&
                <Subscribe to={[MemberContainer]}>
                    {(memberContainer: MemberContainer) => {
                        return (
                            <InviteSparkFormModal
                                isShareFormOpen={isShareFormOpen}
                                setIsShareFormOpen={setIsShareFormOpen}
                                applicationId={props.applicationId}
                                appName={props.appContainer?.state?.currentApp?.name}
                                memberContainer={memberContainer}
                            />
                        )
                    }}

                </Subscribe>
            }
            {isImportFileDialogModalOpen &&
                <ImportFileDialog
                    onClose={toggleImportFileDialogModal}
                    completeImport={importFormFields}
                    title={"Select a .csv File to Import"}
                    acceptFileTypes={".csv"}
                    acceptFileTypesDisplayText={"Supports .csv"}
                    isLoading={false}
                    errors={[]}
                />
            }
            {isClientNotesModalOpen &&
                <NotesModalOverlay
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="spark-location-notes-title"
                    onClick={() => setIsClientNotesModalOpen(false)}
                >
                    <NotesModalPanel onClick={(event) => event.stopPropagation()}>
                        <NotesModalHeader>
                            <NotesModalTitle id="spark-location-notes-title">Location notes</NotesModalTitle>
                            <NotesModalCloseButton
                                type="button"
                                aria-label="Close location notes"
                                onClick={() => setIsClientNotesModalOpen(false)}
                            >
                                <img src={deleteIcon} alt="" />
                            </NotesModalCloseButton>
                        </NotesModalHeader>
                        <NotesModalBody>
                            <SparkApplicationClientNotesEditor
                                appContainer={props.appContainer}
                                commonApp={props.appContainer.state.currentApp}
                                locationApps={[]}
                            />
                        </NotesModalBody>
                    </NotesModalPanel>
                </NotesModalOverlay>
            }
            {isConfirmImportModalOpen &&
                <ConfirmationDialog
                    title={`Confirm Form Fields Import`}
                    deleteText="Yes, Import"
                    isLoading={isLoadingImport}
                    onClose={toggleConfirmImportModal}
                    onConfirm={useImportedTemplateFormFieldValues}>
                    <WarningConfirmation
                        text={`By importing these form fields you will override any existing responses. To preserve existing responses, export them and combine everything into a single file to be imported.`}
                        className={importWarningStyle}
                    />
                </ConfirmationDialog>
            }
            {isAutoAnswerGenerateModalOpen &&
                <Subscribe to={[MediaContainer]}>
                    {(mediaContainer: MediaContainer) => {
                        return (
                            <AutoGenerateFormFieldResponsesFormModal
                                applicationId={props.applicationId}
                                mediaContainer={mediaContainer}
                                appliedAppTemplateContainer={props.appliedAppTemplateContainer}
                                onClose={() => setIsAutoAnswerGenerateModalOpen(false)}
                                isLoading={isLoading}
                                setIsLoading={setIsLoading}
                            />
                        )
                    }}

                </Subscribe>
            }
            <PageError
                errors={errors}
            />
            {goLiveWarnings.length > 0 && (
                <PageError
                    errors={goLiveWarnings}
                    onClear={() => setGoLiveWarnings([])}
                    type="warning"
                />
            )}
        </Wrapper >
    );

};

const importWarningStyle = css`
    margin-top: 32px;
`;

const FormPopulationButton = styled(Button)`
    margin: 0 0 16px 8px;
    font-size: 14px;
    font-weight: 400;
    .right-img {
        margin-left: 8px;
        width: 16px;
    }
`;

const AdminFieldsSwitch = styled(Switch)`
    margin: 8px 0 16px 8px;
`;

const GoLiveSwitch = styled(Switch)`
    margin: 8px 0 16px 8px;
`;

const DateDisplayWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin: 4px 0 16px 8px;
    font-family: Muli, sans-serif;
`;

const DateLabel = styled.span`
    font-size: 12px;
    font-weight: 600;
    color: ${color_shades_darker};
    margin-bottom: 4px;
`;

const TargetDateLabel = styled(DateLabel)`
    font-family: Muli;
    font-size: 14px;
    font-weight: normal;
    color: ${dark_grey_blue};
`;

const DateValueWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const DateValue = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: ${color_shades_darkest};
`;

const TargetDateValue = styled(DateValue)`
    padding: 3px 7px;
    border-radius: 4px;
    background: ${color_variants_ocean_light_1};
`;

const PencilIcon = styled.img`
    width: 14px;
    height: 14px;
    margin-left: 8px;
    cursor: pointer;
    opacity: 0.7;
    &:hover {
        opacity: 1;
    }
`;

const DateEditWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    margin-top: 4px;
`;

const DateInput = styled.input`
    width: 100%;
    max-width: 180px;
    padding: 6px 12px;
    border-radius: 6px;
    border: 1px solid ${color_shades_light};
    font-size: 14px;
    font-family: inherit;
    color: ${color_shades_darkest};
    outline: none;
    background-color: ${color_defaults_white};
    &:focus {
        border-color: ${color_text_link};
    }
`;

const TargetDateInput = styled(DateInput)`
    max-width: 204px;
    box-sizing: border-box;
`;

const ActionButtons = styled.div`
    display: flex;
    gap: 4px;
`;

const TargetDateActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    flex-wrap: nowrap;
    width: 100%;
    max-width: 204px;
    box-sizing: border-box;
`;

const ActionButton = styled.button`
    padding: 6px 12px;
    font-family: inherit;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    border-radius: 4px;
    border: 1px solid ${color_text_link};
    background-color: ${color_text_link};
    color: ${color_defaults_white};
    transition: all 0.15s ease;
    &:hover {
        background-color: ${color_variants_ocean_light_2};
        color: ${color_text_link};
    }
    &.compact {
        padding: 4px 8px;
        white-space: nowrap;
    }
    &.cancel {
        background-color: ${color_defaults_white};
        color: ${color_shades_darker};
        border-color: ${color_shades_light};
        &:hover {
            background-color: ${color_shades_lighter};
            color: ${color_shades_darkest};
        }
    }
`;

const FormPopulationButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    margin-top: 20px;
`;

const NotesModalOverlay = styled.div`
    align-items: center;
    background: rgba(18, 32, 52, 0.42);
    bottom: 0;
    display: flex;
    justify-content: center;
    left: 0;
    padding: 24px;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 3000;
`;

const NotesModalPanel = styled.div`
    background: ${color_defaults_white};
    border-radius: 16px;
    box-shadow: 0 24px 80px rgba(18, 32, 52, 0.24);
    max-height: calc(100vh - 48px);
    overflow: auto;
    width: min(640px, calc(100vw - 48px));
`;

const NotesModalHeader = styled.div`
    align-items: center;
    border-bottom: 1px solid ${color_variants_ocean_light_1};
    display: flex;
    gap: 16px;
    justify-content: space-between;
    padding: 22px 24px 18px;
`;

const NotesModalTitle = styled.h2`
    color: ${color_text_default};
    font-family: Muli, sans-serif;
    font-size: 20px;
    font-weight: 800;
    line-height: 1.2;
    margin: 0;
`;

const NotesModalCloseButton = styled.button`
    align-items: center;
    background: ${color_variants_ocean_light_1};
    border: 0;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 34px;
    justify-content: center;
    padding: 0;
    width: 34px;

    img {
        height: 12px;
        width: 12px;
    }
`;

const NotesModalBody = styled.div`
    padding: 22px 24px 24px;
`;

const CompleteIcon = styled.img``;

const SectionTitle = styled.p``;

const SectionTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    max-width: 90%;
`;

const DeleteButton = styled(Button)`
    margin-left: 0px;
    img {
        width: 8px;
        height: 8px;
    }
`;

const CustomButton = styled(Button)`
    margin: 0 0 0 16px;
    font-size: 14px;
    font-weight: 400;
    .right-img {
        margin-left: 8px;
    }
`;

const SectionItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    height: 48px;
    padding: 0 16px;   
    p {
        font-size: 14px;
        line-height: 20px;
        color: ${color_text_default};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .selected-indicator {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${color_text_link};
        margin-right: 8px;
        margin-left: auto;
    }
    &.active {
        background: ${color_variants_ocean_light_1};
        p {
            color: ${color_text_link}
        }
    }
    &.clickable {
        cursor: pointer;
    }
    &.disabled {
        img {
            display: none;
        }
        p {
            color: ${color_text_light};
        }
    }
    &.review-section {
        margin-bottom: 8px;
        cursor: pointer;
    }
`;

const Wrapper = styled.div`
    box-sizing: border-box;
    height: calc(100vh - 192px);
    overflow-y: auto;
    padding: 16px;
`;

const TopicButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const FieldResultItem = styled.div`
    display: flex;
    align-items: center;
    border-radius: 4px;
    height: 40px;
    padding: 0 16px 0 32px;
    cursor: pointer;
    p {
        font-size: 13px;
        line-height: 18px;
        color: ${color_text_light};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    &:hover {
        background: ${color_variants_ocean_light_1};
        p {
            color: ${color_text_link};
        }
    }
`;

const searchFieldStyle = css`
    margin-bottom: 8px;
`;

const ButtonsWrapper = styled.div`
    background: ${color_defaults_white};
    position: sticky;
    bottom: 0;
`;


export default AppliedAppSectionSelector;
